module.exports = __webpack_public_path__ + "img/upload.43d81287.svg";